<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/background-introducao.png');">
    <div class="layout">
      <h1 class="title-page">Institucional</h1>
    </div>
  </section>

  <app-diferentials></app-diferentials>

  <section class="wrap-proposities">
    <div class="layout">
      <div class="column">
        <div class="icon">
          <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/proposito.svg" alt="Proposito" loading="lazy">
        </div>
        <div class="text">
          <h2 class="subtitle">Propósito</h2>
          <hr>
          <div class="ckeditor">
            <p>Acreditamos na informação como o item de maior valor em uma negociação. Por isso entregamos os dados mais
              confiáveis e atualizados do mercado, confiança que vai da informação ao atendimento e flexibilidade para
              adaptar as soluções de acordo com a necessidade da sua empresa.</p>
            <p>Nosso compromisso é o seu sucesso. A equipe Union está ao seu lado de forma dedicada e disponível para
              que o seu negócio nunca fique na mão.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section appAppearOnScroll class="wrap-values">
    <div  class="layout">
      <div class="column">
        <div class="icon">
          <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/missao.png" alt="Missão" loading="lazy">
        </div>
        <div class="text">
          <h3>Missão</h3>
          <p>Ser referência nacional no fornecimento de soluções à empresas, facilitando a tomada de decisão nas
            transações envolvendo veículos seminovos.</p>
        </div>
      </div>
      <div class="column">
        <div class="icon">
          <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/visao.png" alt="Visão" loading="lazy">
        </div>
        <div class="text">
          <h3>Visão</h3>
          <p>Está presente em todo o território nacional, proporcionando soluções e transparência para as empresas do
            mercado veicular.</p>
        </div>
      </div>
      <div class="column">
        <div class="icon">
          <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/valores.png" alt="Valores" loading="lazy">
        </div>
        <div class="text">
          <h3>Valores</h3>
          <p>Transparência, contribuir para o universo automotivo, dados atualizados e confiáveis, modernidade,
            exclusividade, inovação, excelência em soluções veiculares.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="wrap-history">
    <div class="layout">
      <div class="column">
        <div class="text">
          <h2 class="subtitle">História</h2>
          <div class="ckeditor">
            <p>Com mais de 10 anos de experiência, a Union Solutions surgiu para entregar soluções de tecnologia,
              inteligência e informações veiculares para a sua empresa. A parceria com empresas de credibilidade e as
              ferramentas próprias permitem oferecer segurança, confiabilidade e procedência para garantir sempre a
              melhor negociação entre pessoas e veículos novos, seminovos ou usados.</p>
            <p>A atuação em território nacional permite que a nossa equipe faça a união entre o conhecimento com a
              regionalização do processo. Através de um intenso treinamento, eles encontram as melhores soluções em
              tecnologia, inteligência e informações de acordo com o que a sua empresa precisa.</p>
          </div>
          <p class="highlight">Segurança, confiabilidade e procedência. Em uma só ferramenta.</p>
        </div>
      </div>
      <div class="column">
        <figure appAppearRightOnScroll class="foto">
          <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/institucional.png" alt="Institucional" loading="lazy">
        </figure>
      </div>
    </div>
  </section>

  <app-testimonials></app-testimonials>

  <section class="wrap-solutions">
    <div class="layout">
      <h2 class="subtitle">Soluções em negócios veiculares</h2>
      <p class="description">Não deixamos passar nenhum detalhe. A Union é o parceiro confiável e detalhista que
        oferece a base de dados mais completa para tomar a melhor decisão para suas negociações. </p>
      <div class="list-solutions">
        <a class="solution-card" href="/solucao/gestao-de-entrada-de-seminovos/">
          <div class="photo">
            <svg xmlns="http://www.w3.org/2000/svg" width="59.989" height="54.517" viewBox="0 0 59.989 54.517">
              <defs>
                <style>
                  .a {
                    fill: #003e52;
                  }
                </style>
              </defs>
              <g transform="translate(0 26.234)">
                <path class="a" d="M210.481,401h-2.2a.915.915,0,0,0,0,1.828h2.2a.915.915,0,0,0,0-1.828Z"
                  transform="translate(-183.1 -385.733)"></path>
                <path class="a"
                  d="M82.3,297H80.2a10.1,10.1,0,0,0-7.311,3.14,14.587,14.587,0,0,1-2.964,2.343,1.649,1.649,0,0,0-.75,1.781,3.629,3.629,0,0,0,3.5,2.859H82.3a1.259,1.259,0,0,0,1.23-1.289v-7.546A1.259,1.259,0,0,0,82.3,297Zm-.527,8.3H72.679a1.839,1.839,0,0,1-1.746-1.312,15.255,15.255,0,0,0,3.2-2.554,8.379,8.379,0,0,1,6.069-2.6h1.57Z"
                  transform="translate(-61.033 -293.919)"></path>
                <path class="a"
                  d="M223.385,303.5c-.363-.211-.738-.445-1.078-.691l-5.647-3.96a10.068,10.068,0,0,0-5.8-1.851h-4.323a1.161,1.161,0,0,0-1.137,1.172v7.768a1.153,1.153,0,0,0,1.137,1.172H223.4a1.328,1.328,0,0,0,1.3-1.336A2.618,2.618,0,0,0,223.385,303.5ZM207.169,305.3v-6.468h3.691a8.314,8.314,0,0,1,4.816,1.535l5.647,3.96c.4.281.808.539,1.219.773a.608.608,0,0,1,.223.2Z"
                  transform="translate(-181.334 -293.919)"></path>
                <path class="a"
                  d="M69.471,437.8a2.8,2.8,0,0,0-2.027.879,3.037,3.037,0,0,0-.844,2.109,2.987,2.987,0,0,0,.844,2.109,2.777,2.777,0,0,0,4.054,0,3.038,3.038,0,0,0,.844-2.109,2.986,2.986,0,0,0-.844-2.109A2.8,2.8,0,0,0,69.471,437.8Zm.785,3.808a1.077,1.077,0,0,1-1.57,0,1.189,1.189,0,0,1,0-1.64,1.077,1.077,0,0,1,1.57,0,1.189,1.189,0,0,1,0,1.64Z"
                  transform="translate(-58.797 -418.221)"></path>
                <path class="a"
                  d="M398.471,437.8a2.8,2.8,0,0,0-2.027.879,3.038,3.038,0,0,0-.844,2.109,2.986,2.986,0,0,0,.844,2.109,2.777,2.777,0,0,0,4.054,0,3.058,3.058,0,0,0,0-4.218A2.8,2.8,0,0,0,398.471,437.8Zm.785,3.808a1.077,1.077,0,0,1-1.57,0,1.189,1.189,0,0,1,0-1.64,1.077,1.077,0,0,1,1.57,0,1.189,1.189,0,0,1,0,1.64Z"
                  transform="translate(-349.249 -418.221)"></path>
                <path class="a"
                  d="M59.251,284.467,58.982,284h0a7.065,7.065,0,0,0-4.652-3.4L46.538,279a11.612,11.612,0,0,1-4.089-2.015l-5.659-3.96c-.059-.047-.129-.082-.187-.129a17.783,17.783,0,0,0-2.179-1.219,13.712,13.712,0,0,0-1.922-.609,12.106,12.106,0,0,0-2.976-.363H19.157a12.646,12.646,0,0,0-9.151,3.925,11.132,11.132,0,0,1-5.612,3.152l-1.23.281A4.119,4.119,0,0,0,0,282.1v7.616a2.61,2.61,0,0,0,1.5,2.39l3.7,1.711a5.743,5.743,0,0,0,1.582,3.468,5.332,5.332,0,0,0,3.89,1.687,5.391,5.391,0,0,0,3.89-1.664A5.769,5.769,0,0,0,16.1,294.18h27.71a5.773,5.773,0,0,0,1.535,3.128,5.34,5.34,0,0,0,7.768,0,5.655,5.655,0,0,0,1.535-3.128H56.8a3.257,3.257,0,0,0,3.187-3.316v-3.632A5.55,5.55,0,0,0,59.251,284.467Zm-57.494.914h1.16v1.828H1.757ZM13.31,296.008a3.646,3.646,0,0,1-5.284,0,4.009,4.009,0,0,1,0-5.5,3.626,3.626,0,0,1,5.272,0A4,4,0,0,1,13.31,296.008Zm38.548,0a3.61,3.61,0,0,1-2.636,1.137,3.655,3.655,0,0,1-2.636-1.137,3.953,3.953,0,0,1-1.09-2.742,3.912,3.912,0,0,1,1.09-2.742,3.626,3.626,0,0,1,5.272,0,3.994,3.994,0,0,1,0,5.483Zm6.374-5.144a1.464,1.464,0,0,1-1.429,1.488H54.646a5.773,5.773,0,0,0-1.535-3.128,5.353,5.353,0,0,0-7.78,0,5.655,5.655,0,0,0-1.535,3.128H16.087a5.808,5.808,0,0,0-1.535-3.128,5.353,5.353,0,0,0-7.768,0A5.717,5.717,0,0,0,5.331,291.9l-3.117-1.441a.79.79,0,0,1-.457-.726v-.691H3.3a1.411,1.411,0,0,0,1.383-1.429v-2.613A1.411,1.411,0,0,0,3.3,283.565H1.757V282.1a2.293,2.293,0,0,1,1.769-2.261l1.23-.269a12.783,12.783,0,0,0,6.491-3.644,10.953,10.953,0,0,1,7.92-3.4H29.526a10.827,10.827,0,0,1,2.6.316.341.341,0,0,0,.105.023,11.012,11.012,0,0,1,3.574,1.652l5.647,3.96a13.017,13.017,0,0,0,4.734,2.285l7.792,1.605a5.138,5.138,0,0,1,2.332,1.148,2.689,2.689,0,0,0-2.156,2.66v1.429a1.441,1.441,0,0,0,1.418,1.465h2.66Zm0-3.62h-2.32V286.2a.863.863,0,0,1,.844-.879h.937l.047.082a3.693,3.693,0,0,1,.492,1.84Z"
                  transform="translate(0 -270.7)"></path>
              </g>
              <g transform="translate(13.849 0)">
                <path class="a"
                  d="M228.951,166.151v-5.378a2.275,2.275,0,0,0-2.273-2.273h-21.8a2.275,2.275,0,0,0-2.273,2.273V172.6h1.757V160.773a.52.52,0,0,1,.516-.516h21.8a.52.52,0,0,1,.516.516v5.378h-.012v6.995a.52.52,0,0,1-.516.516H214.117a18.08,18.08,0,0,1,2.46,1.757h10.111a2.275,2.275,0,0,0,2.273-2.273v-6.995Z"
                  transform="translate(-192.711 -145.413)"></path>
                <path class="a"
                  d="M163.028,46.8H119.489a1.293,1.293,0,0,0-1.289,1.289v5.144a1.293,1.293,0,0,0,1.289,1.289h1.031V71.159a.879.879,0,1,0,1.757,0V54.521h5.811v.387a2.275,2.275,0,0,0,2.273,2.273h21.8a2.275,2.275,0,0,0,2.273-2.273v-.387h5.8V81.341a.879.879,0,1,0,1.757,0V54.521h1.031a1.293,1.293,0,0,0,1.289-1.289V48.089A1.278,1.278,0,0,0,163.028,46.8ZM152.67,54.908a.52.52,0,0,1-.516.516H130.362a.52.52,0,0,1-.516-.516V52.19a.52.52,0,0,1,.516-.516h21.8a.52.52,0,0,1,.516.516v.3h-.012Zm9.912-2.144H154.44V52.19a2.275,2.275,0,0,0-2.273-2.273h-21.8a2.275,2.275,0,0,0-2.273,2.273v.574h-8.131V48.557h42.625Z"
                  transform="translate(-118.2 -46.8)"></path>
              </g>
            </svg>
          </div>
          <div class="infos">
            <h3>Gestão de Entrada de Seminovos</h3>
            <p>Para quem busca mais assertividade na precificação e rentabilidade nas negociações. Sem fórmulas prontas,
              a Union proporciona a gestão que vai reduzir os riscos e promover aumento do faturamento da sua
              concessionária.</p>
          </div>
        </a>
        <a class="solution-card" href="/solucao/consulta-veicular/">
          <figure class="photo">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/consultas.png" alt="Consulta Veicular">
          </figure>
          <div class="infos">
            <h3>Consulta Veicular</h3>
            <p>Esqueça os pacotes "prontos"! Na Union você personaliza as informações de acordo com as necessidades
              específicas da sua empresa e paga apenas por isso. É hora de tomar a decisão certa.</p>
          </div>
        </a>
        <a class="solution-card" href="/solucao/decisao-certa/">
          <div class="photo">
            <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62">
              <defs>
                <style>
                  .a {
                    fill: #003e52;
                  }
                </style>
              </defs>
              <g transform="translate(-164 -941)">
                <path class="a"
                  d="M157.49,84.6a.909.909,0,0,0-1.285,0l-2.212,2.212-1.255-1.256a.909.909,0,0,0-1.285,1.285l1.9,1.9a.91.91,0,0,0,1.285,0l2.852-2.852a.909.909,0,0,0,0-1.285Z"
                  transform="translate(31.541 867.122)"></path>
                <path class="a"
                  d="M157.49,150.662a.909.909,0,0,0-1.285,0l-2.212,2.212-1.255-1.256a.909.909,0,0,0-1.285,1.285l1.9,1.9a.909.909,0,0,0,1.285,0l2.852-2.852a.909.909,0,0,0,0-1.285Z"
                  transform="translate(31.541 809.253)"></path>
                <path class="a"
                  d="M157.668,218.122a.909.909,0,0,0-1.285,0l-2.212,2.211-1.255-1.255a.908.908,0,0,0-1.285,1.276l1.9,1.9a.909.909,0,0,0,1.285,0l2.852-2.852a.908.908,0,0,0,0-1.283Z"
                  transform="translate(31.363 750.158)"></path>
                <path class="a"
                  d="M4.179,61.995H57.821A4.2,4.2,0,0,0,62,57.785V55.337a1.619,1.619,0,0,0-1.612-1.621h-3.1a5.112,5.112,0,0,0,1.182-3.254V37.4a.909.909,0,1,0-1.817,0V50.463a3.341,3.341,0,0,1-2.728,3.259H8.071a3.339,3.339,0,0,1-2.728-3.259V18.8a3.316,3.316,0,0,1,3.312-3.312h4.9v1.947H8.987A1.668,1.668,0,0,0,7.322,19.1V50.111a1.667,1.667,0,0,0,1.665,1.665h44.02a1.668,1.668,0,0,0,1.676-1.665V19.1a1.668,1.668,0,0,0-1.665-1.665H48.436V15.487h4.9A3.317,3.317,0,0,1,56.653,18.8V33.162a.909.909,0,0,0,1.817,0V18.8a5.135,5.135,0,0,0-5.13-5.129h-4.9V2.493a2.5,2.5,0,0,0-2.5-2.5H33.119a.909.909,0,1,0,0,1.817H45.938a.682.682,0,0,1,.682.681V44.341a.655.655,0,0,1-.655.653H16.034a.655.655,0,0,1-.655-.653V8.862h4.553a2.5,2.5,0,0,0,2.5-2.5V1.812h6.448a.909.909,0,0,0,0-1.817H21.523a.91.91,0,0,0-.642.267L13.83,7.312a.918.918,0,0,0-.267.642V13.67h-4.9A5.135,5.135,0,0,0,3.53,18.8V50.463a5.112,5.112,0,0,0,1.188,3.259H1.612A1.612,1.612,0,0,0,0,55.337v2.448a4.2,4.2,0,0,0,4.179,4.21ZM20.614,3.1V6.364a.682.682,0,0,1-.682.682H16.664ZM16.034,46.811H45.965a2.471,2.471,0,0,0,2.47-2.47V19.25h4.426V49.96H9.139V19.25h4.424V44.341a2.48,2.48,0,0,0,2.471,2.47Zm7.1,8.722H38.87v.734a.56.56,0,0,1-.546.559H23.675a.559.559,0,0,1-.546-.559Zm-21.313,0h19.5v.734a2.371,2.371,0,0,0,2.362,2.38H38.325a2.372,2.372,0,0,0,2.362-2.376v-.734h19.5v2.252a2.381,2.381,0,0,1-2.362,2.393H4.179a2.381,2.381,0,0,1-2.362-2.393Z"
                  transform="translate(164 941.005)"></path>
                <path class="a" d="M235.544,83h-14.8a.909.909,0,0,0,0,1.817h14.8a.909.909,0,0,0,0-1.817Z"
                  transform="translate(-28.607 868.292)"></path>
                <path class="a" d="M235.544,111.9h-14.8a.909.909,0,0,0,0,1.817h14.8a.909.909,0,0,0,0-1.817Z"
                  transform="translate(-28.607 842.976)"></path>
                <path class="a" d="M235.544,150.4h-14.8a.909.909,0,0,0,0,1.817h14.8a.909.909,0,0,0,0-1.817Z"
                  transform="translate(-28.607 809.25)"></path>
                <path class="a" d="M235.544,179.3h-14.8a.909.909,0,0,0,0,1.817h14.8a.909.909,0,0,0,0-1.817Z"
                  transform="translate(-28.607 783.934)"></path>
                <path class="a" d="M235.544,217.8h-14.8a.909.909,0,0,0,0,1.817h14.8a.909.909,0,0,0,0-1.817Z"
                  transform="translate(-28.607 750.208)"></path>
                <path class="a" d="M235.316,246.71h-14.8a.908.908,0,1,0,0,1.815h14.8a.908.908,0,0,0,0-1.815Z"
                  transform="translate(-28.378 724.882)"></path>
                <path class="a"
                  d="M156.205,285.318l-2.212,2.212-1.255-1.256a.909.909,0,0,0-1.285,1.285l1.9,1.9a.908.908,0,0,0,1.283,0l2.852-2.852a.909.909,0,1,0-1.285-1.285Z"
                  transform="translate(31.541 691.313)"></path>
                <path class="a" d="M235.544,285.2h-14.8a.909.909,0,0,0,0,1.817h14.8a.909.909,0,0,0,0-1.817Z"
                  transform="translate(-28.607 691.165)"></path>
                <path class="a" d="M235.544,314.11h-14.8a.909.909,0,0,0,0,1.817h14.8a.909.909,0,0,0,0-1.817Z"
                  transform="translate(-28.607 665.84)"></path>
              </g>
            </svg>
          </div>
          <div class="infos">
            <h3>Decisão Certa</h3>
            <p>Negociações mais assertivas com a ferramenta mais confiável e atualizada do mercado. São mais de 160
              itens de verificação personalizáveis de acordo com as necessidades da sua empresa.</p>
          </div>
        </a>
      </div>
      <div class="button">
        <a class="btn gradient" href="/solucoes">Ver todas as soluções</a>
      </div>
    </div>
  </section>

  <app-contact-box></app-contact-box>

</main>
